///masterhardwarecatalog/list
export const MASTER_HARDWARE_CATALOG_LIST = "MASTER_HARDWARE_CATALOG_LIST";
export const MASTER_HARDWARE_CATALOG_LIST_SUCCESS =
  "MASTER_HARDWARE_CATALOG_LIST_SUCCESS";
export const MASTER_HARDWARE_CATALOG_LIST_FAILURE =
  "MASTER_HARDWARE_CATALOG_LIST_FAILURE";
///masterhardwarecatalog/create
export const MASTER_HARDWARE_CATALOG_CREATE = "MASTER_HARDWARE_CATALOG_CREATE";
export const MASTER_HARDWARE_CATALOG_CREATE_SUCCESS =
  "MASTER_HARDWARE_CATALOG_CREATE_SUCCESS";
export const MASTER_HARDWARE_CATALOG_CREATE_FAILURE =
  "MASTER_HARDWARE_CATALOG_CREATE_FAILURE";
///masterhardwarecatalog/update
export const MASTER_HARDWARE_CATALOG_UPDATE = "MASTER_HARDWARE_CATALOG_UPDATE";
export const MASTER_HARDWARE_CATALOG_UPDATE_SUCCESS =
  "MASTER_HARDWARE_CATALOG_UPDATE_SUCCESS";
export const MASTER_HARDWARE_CATALOG_UPDATE_FAILURE =
  "MASTER_HARDWARE_CATALOG_UPDATE_FAILURE";
///masterhardwarecatalog/delete
export const MASTER_HARDWARE_CATALOG_DELETE = "MASTER_HARDWARE_CATALOG_DELETE";
export const MASTER_HARDWARE_CATALOG_DELETE_SUCCESS =
  "MASTER_HARDWARE_CATALOG_DELETE_SUCCESS";
export const MASTER_HARDWARE_CATALOG_DELETE_FAILURE =
  "MASTER_HARDWARE_CATALOG_DELETE_FAILURE";
